<div *ngIf="orgName" class="org-header-card card shadow-sm rounded-4 border-0 mb-3">
  <div class="card-body py-3 px-4">
    <h6 class="org-title mb-0 text-primary">
      Parent Organization: {{ orgName }}
    </h6>
  </div>
</div>

<div class="add-customer-container">
  <div class="card shadow-sm rounded-4 border-0">
    <div class="card-body p-4">
      <div *ngIf="submitSuccess" class="alert alert-success col-md-7" role="alert">
        User added successfully.
      </div>
      <div *ngIf="submitError" class="alert alert-danger col-md-7" role="alert">
       A server error occured. Please try again later.
      </div>
      <form [formGroup]="userForm" (ngSubmit)="onSubmit()" class="user-form p-3 rounded bg-white shadow-sm">
        <div class="mb-2">
          <label for="firstName" class="form-label">
            First Name <span class="text-danger">*</span>
          </label>
          <input id="firstName"
                 class="form-control"
                 [ngClass]="{'is-invalid': userForm.get('firstName')?.invalid && userForm.get('firstName')?.touched}"
                 formControlName="firstName"
                 placeholder="First Name"
                 (blur)="onFirstNameBlur()" />
          <div class="text-danger mt-1" *ngIf="userForm.get('firstName')?.invalid && userForm.get('firstName')?.touched">
            First name is required.
          </div>
        </div>
        <div class="mb-2">
          <label for="lastName" class="form-label">
            Last Name <span class="text-danger">*</span>
          </label>
          <input id="lastName"
                 class="form-control"
                 [ngClass]="{'is-invalid': userForm.get('lastName')?.invalid && userForm.get('lastName')?.touched}"
                 formControlName="lastName"
                 placeholder="Last Name"
                 (blur)="onLastNameBlur()" />
          <div class="text-danger mt-1" *ngIf="userForm.get('lastName')?.invalid && userForm.get('lastName')?.touched">
            Last name is required.
          </div>
        </div>
        <div class="mb-2">
          <label for="externalId" class="form-label">External ID</label>
          <input id="externalId" class="form-control" formControlName="externalId" placeholder="External ID" />
        </div>
        <div class="mb-2">
          <label for="npiNumber" class="form-label">NPI Number</label>
          <input id="npiNumber" class="form-control" formControlName="npiNumber" placeholder="NPI Number" />
        </div>
        <div class="mb-2">
          <label for="email" class="form-label">
            Email <span class="text-danger">*</span>
          </label>
          <input id="email"
                 class="form-control"
                 [ngClass]="{'is-invalid': userForm.get('email')?.invalid && userForm.get('email')?.touched}"
                 formControlName="email"
                 placeholder="Email"
                 type="email"
                 (blur)="userForm.get('email')?.markAsTouched()" />
          <div class="text-danger mt-1" *ngIf="userForm.get('email')?.invalid && userForm.get('email')?.touched">
            Valid email is required.
          </div>
        </div>
        <div class="mb-2">
          <label for="username" class="form-label">
            Username <span class="text-danger">*</span>
          </label>
          <div class="input-group">
            <input id="username"
                   class="form-control"
                   [ngClass]="{'is-invalid': userForm.get('username')?.invalid && userForm.get('username')?.touched}"
                   formControlName="username"
                   placeholder="Username"
                   (blur)="userForm.get('username')?.markAsTouched()" />
            <button class="btn refresh-btn" 
                    type="button" 
                    (click)="onRefreshUsername()"
                    title="Generate username from first and last name">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="23 4 23 10 17 10"></polyline>
                <polyline points="1 20 1 14 7 14"></polyline>
                <path d="m3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path>
              </svg>
            </button>
          </div>
          <div class="text-danger mt-1" *ngIf="userForm.get('username')?.invalid && userForm.get('username')?.touched">
            Username is required.
          </div>
        </div>
        <div class="mb-2">
          <label for="password" class="form-label">Password</label>
          <div class="input-group">
            <input id="password" 
                   class="form-control" 
                   formControlName="password" 
                   placeholder="Password" 
                   [type]="showPassword ? 'text' : 'password'" />
            <button class="btn refresh-btn" 
                    type="button" 
                    (click)="onRefreshPassword()"
                    title="Generate new password">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="23 4 23 10 17 10"></polyline>
                <polyline points="1 20 1 14 7 14"></polyline>
                <path d="m3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path>
              </svg>
            </button>
            <button class="btn password-toggle-btn" 
                    type="button" 
                    (click)="togglePasswordVisibility()"
                    title="Toggle password visibility">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path *ngIf="!showPassword" d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                <circle *ngIf="!showPassword" cx="12" cy="12" r="3"></circle>
                <path *ngIf="showPassword" d="m1 1 22 22"></path>
                <path *ngIf="showPassword" d="M6.71 6.71C5.68 7.78 5 9.32 5 12s4 8 11 8c1.55 0 2.98-.26 4.24-.71"></path>
                <path *ngIf="showPassword" d="M2 12s3-7 10-7c1.1 0 2.16.18 3.16.5"></path>
                <path *ngIf="showPassword" d="M14 14.12c-.39.39-.9.61-1.41.61-1.1 0-2-.9-2-2 0-.51.22-1.02.61-1.41"></path>
              </svg>
            </button>
          </div>
          <div class="text-danger mt-1" *ngIf="userForm.get('password')?.invalid && userForm.get('password')?.touched">
            Password is required.
          </div>
        </div>
        <div class="mb-2">
          <label for="roles" class="form-label">
            Roles <span class="text-danger">*</span>
          </label>
          <mat-form-field appearance="fill" class="w-100"
            [ngClass]="{'is-invalid': userForm.get('roles')?.invalid && userForm.get('roles')?.touched}">
            <mat-label>Roles</mat-label>
            <mat-select id="roles"
                        formControlName="roles"
                        multiple
                        (blur)="userForm.get('roles')?.markAsTouched()">
              <mat-option *ngFor="let set of permissionSets" [value]="set.permissionSetId">{{ set.name }}</mat-option>
            </mat-select>
          </mat-form-field>
          <div class="text-danger mt-1" *ngIf="userForm.get('roles')?.invalid && userForm.get('roles')?.touched">
            At least one role is required.
          </div>
        </div>
        <div class="form-check mb-2">
          <input type="checkbox" class="form-check-input" id="active" formControlName="active" />
          <label class="form-check-label" for="active">Active</label>
        </div>
        <div class="form-check mb-2">
          <input type="checkbox" class="form-check-input" id="excludeReferrals" formControlName="excludeReferrals" />
          <label class="form-check-label" for="excludeReferrals">Exclude Referrals</label>
        </div>
        <button type="submit"
                class="btn btn-gradient w-100 py-3 mt-3"
                [disabled]="isSubmitting || userForm.invalid">
          {{ isSubmitting ? 'Saving...' : 'Save User' }}
        </button>
      </form>
    </div>
  </div>
</div>